<div class="container-fluid">
  <h1 class="my-2 display-2">Convert Xml to JSON</h1>
  <div class="row">

      <div class="col-md-5">
        <div class="form-group">
              <label for="code"><strong>Paste your Xml here or paste  link to an Xml file </strong></label>
              <textarea rows="15" cols="7" class="form-control" [(ngModel)]="code" name="code" id="code" placeholder="Paste your code snippet here...or link to an XML file" required></textarea>
        </div>

      </div>

      <div class="col-md-1">
      <button class="btn btn-success mt-2" (click)="convertXmlToJson()">Convert</button>
        <!-- <div class="form-group mt-3">
        <label for="language">Select Language</label>
          <select name="language" [(ngModel)]="codeRequest.language" class="form-control">select
            <option *ngFor="let language of languages" value="{{ language }}">{{ language }}</option>
          </select>
        </div> -->
      </div>

      <div class="col-md-5 ml-0">
          <div class="form-group">
              <label for="code">Result</label>
              <pre><textarea rows="15" cols="7" class="form-control" [(ngModel)]="output" value="{{ output }}" name="code" id="code"></textarea></pre>
        </div>
      </div>

  </div>
</div>
